import React from 'react'
import { ScheduleCategoriesWrapper } from 'components/Owner/Plays/style'

const OptionalPlays = ({ title, optionalplays }) => {
  return (
    <ScheduleCategoriesWrapper>
      <div className="text-primary-text font-normal text-lg text-center mb-4">{title}</div>
      {optionalplays?.map((play, index) => {
        return (
          <div className="categoryBlock" key={index}>
            <div className="flex gap-3 items-center categoriesList">
              <div className="Dot bg-primary"></div>
              <div className="font-medium text-lg"> {play}</div>
            </div>
          </div>
        )
      })}
    </ScheduleCategoriesWrapper>
  )
}

export default OptionalPlays
